import React from 'react';

import * as S from './styles';

function Home() {
  return <S.Iohome />;
}

export default Home;